<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>研发材料报销</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择产品" class="select2">
              <el-option key="" label="请选择产品" value=""></el-option>
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" placeholder="选择开始日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.endtime" type="date" placeholder="选择结束日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.orderidcaigou" placeholder="请输入订单号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.shoukuandanwei" placeholder="请输入供应商名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.spstatus" placeholder="请选择" style="width: 100%">
              <el-option label="请选择审批状态" value="-1"></el-option>
              <el-option label="审批不通过" value="0"></el-option>
              <el-option label="待部门主管审核" value="1"></el-option>
              <el-option label="待财务主管审核" value="2"></el-option>
              <el-option label="待副总经理审核" value="3"></el-option>
              <el-option label="待总经理审核" value="4"></el-option>
              <el-option label="审批通过" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.printstatus" placeholder="请选择" style="width: 100%">
              <el-option label="请选择打印状态" value="-1"></el-option>
              <el-option label="未打印" value="0"></el-option>
              <el-option label="已打印" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.productname" @keyup.enter.native="clicksearch" placeholder="请输入材料名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.reason" @keyup.enter.native="clicksearch" placeholder="请输入材料用途" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.beizhu" @keyup.enter.native="clicksearch" placeholder="请输入备注" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Createtime" label="填制日期" min-width="8%"></el-table-column>
          <el-table-column prop="Orderid" label="表单号" min-width="8%"></el-table-column>
          <el-table-column prop="Bomsnname" label="产品名称" min-width="8%"></el-table-column>
          <el-table-column prop="Spstatusname" label="审核状态" min-width="8%"></el-table-column>
          <!-- <el-table-column prop="ShangJigouName" label="所属公司" min-width="8%"></el-table-column> -->
          <el-table-column prop="CurJigouName" label="申请部门" min-width="10%"></el-table-column>
          <el-table-column prop="Name1" label="报销人" min-width="5%"></el-table-column>
          <el-table-column prop="Shoukuandanwei" label="供应商" min-width="7%"></el-table-column>
          <el-table-column prop="Contact" label="联系方式" min-width="5%"></el-table-column>
          <el-table-column prop="Productname" label="材料名称" min-width="7%"></el-table-column>
          <el-table-column prop="Reason" label="材料用途" min-width="8%"></el-table-column>
          <el-table-column prop="Productnum" label="数量" min-width="4%"></el-table-column>
          <el-table-column prop="Productprice" label="单价" min-width="4%"></el-table-column>
          <el-table-column prop="Money" label="含税金额" min-width="4%"></el-table-column>
          <el-table-column prop="Moneynotax" label="未税金额" min-width="4%"></el-table-column>
          <el-table-column prop="Moneytax" label="税金" min-width="4%"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" min-width="10%"></el-table-column>
          <el-table-column prop="Spopinion" label="审批意见" min-width="5%"></el-table-column>
          <el-table-column prop="Spreply" label="意见答复" min-width="5%"></el-table-column>
          <el-table-column label="附件" min-width="7%">
            <template v-slot="scope">
              <el-button v-for="Attachment in scope.row.Attachments" type="text" @click="clickfile(Attachment)">附件</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Printstatusname" label="打印状态" min-width="7%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Spstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
              <el-button v-if="scope.row.Spstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Spstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe0(scope.row)">再次提交审核</el-button>
              <el-button v-if="scope.row.Spstatus == 1 && SubRule_ShenPiNewFyBxChaiLv_BuMen" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,1)">部门主管审核</el-button>
              <el-button v-if="scope.row.Spstatus == 2 && SubRule_ShenPiNewFyBxChaiLv_CaiWu" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,2)">财务审核</el-button>
              <el-button v-if="scope.row.Spstatus == 3 && SubRule_ShenPiNewFyBxChaiLv_FuZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,3)">副总经理审核</el-button>
              <el-button v-if="scope.row.Spstatus == 4 && SubRule_ShenPiNewFyBxChaiLv_Zong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,4)">总经理审核</el-button>
              <el-button v-if="scope.row.Spstatus == 5 && SubRule_ShenPiNewFyBxChaiLv_Print" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdialogprint(scope.row)">打印</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickView(scope.row)">查看单据</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 审批 start -->
        <el-dialog
          title=""
          :visible.sync="dialogShenPi"
          width="880px">
          <printyanfabaoxiao ref="ShenPiViewyanfabaoxiao"></printyanfabaoxiao>
          <el-form :model="modelShenPi" ref="modelShenPi" label-width="170px">
            <el-form-item label="税金" class="addAdminForm" v-if="modelShenPi.iscaiwushenpi">
              <el-input v-model="modelShenPi.moneytax"></el-input>
            </el-form-item>
            <el-form-item label="审批意见(可选)" class="addAdminForm">
              <el-input v-model="modelShenPi.spopinion" placeholder="如果拒绝,请填写审批意见"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="ShenHeOK">同意</el-button>
              <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 审批 end -->

        <el-dialog
          title="再次提交审核"
          :visible.sync="dialogSubmitAgain"
          width="35%">
          <el-form :model="modelSubmitAgain" ref="modelSubmitAgain" label-width="170px">
            <el-form-item label="答复审批意见" class="addAdminForm">
              <el-input v-model="modelSubmitAgain.spreply" placeholder="请填写答复"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="SubmitAgain">提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加研发材料报销" name="second">
      <el-form :model="addFormYanfaBx" ref="addFormYanfaBxRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">产品名称(必须)</span>
          </label>
          <el-select v-model="addFormYanfaBx.bomsn" placeholder="请选择产品" class="select2">
            <el-option
              v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">供应商(必填)</span>
          </label>
          <el-input v-model="addFormYanfaBx.shoukuandanwei"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">联系方式(必填)</span>
          </label>
          <el-input v-model="addFormYanfaBx.contact"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">材料名称(必填)</span>
          </label>
          <el-input v-model="addFormYanfaBx.productname"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">材料用途(必填)</span>
          </label>
          <el-input v-model="addFormYanfaBx.reason"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">数量(必填)</span>
          </label>
          <el-input v-model="addFormYanfaBx.productnum" @change="countmoney"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">单价(必填)</span>
          </label>
          <el-input v-model="addFormYanfaBx.productprice" @change="countmoney"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">金额(必填)</span>
          </label>
          <el-input v-model="addFormYanfaBx.money" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="addFormYanfaBx.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickaddYanfaBx">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- start -->
    <el-tab-pane label="修改研发材料报销" name="three" disabled="disabled">
      <ShenPiNewYanfaBxEdit ref="SubVuethree" v-on:triggerFunc="BackToFirst"></ShenPiNewYanfaBxEdit>
    </el-tab-pane>
    <!-- end -->

    <el-dialog
      title=""
      :visible.sync="dialogPrint"
      width="880px">
      <div id="printAreaName">
        <printyanfabaoxiao ref="PrintViewyanfabaoxiao"></printyanfabaoxiao>
      </div>
      <el-button type="success" v-print="`#printAreaName`">打印</el-button>
      <el-button type="success" @click="apiShenPiNewFyBxChaiLvPrint">设置为已经打印</el-button>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogView"
      width="880px">
      <printyanfabaoxiao ref="PrintViewyanfabaoxiao"></printyanfabaoxiao>
    </el-dialog>

  </el-tabs>
  </div>
</template>

<script>
import printyanfabaoxiao from '@/componentsprint/printyanfabaoxiao.vue'
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import ShenPiNewYanfaBxEdit from '@/componentsSubVue/ShenPiNewYanfaBxEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    printyanfabaoxiao,
    RsljigouInternal,
    TencentyunCosUploadMultiImgOrPdf,
    ShenPiNewYanfaBxEdit
  },
  name: 'MyShenPiNewYanfaBx',
  data () {
    return {
      useriderp: 0,
      activeName: 'first',
      optionsproduct: [],
      addFormYanfaBx: {
        bomsn: '',
        shoukuandanwei: '',
        contact: '',
        productname: '',
        reason: '',
        productnum: '',
        productprice: '',
        money: '',
        beizhu: '',
        attachment: ''
      },
      modelShenPi: {
        spid: 0,
        spopinion: '',
        iscaiwushenpi: false,
        moneytax: ''
      },
      modelSubmitAgain: {
        spid: 0,
        spreply: ''
      },
      // 查询
      keywords: {
        bomsn: '',
        begintime: '',
        endtime: '',
        jigouid: '-1',
        jigouname: '',
        createuserid: 0,
        fytype: '300',
        orderidcaigou: '',
        shoukuandanwei: '',
        spstatus: '-1',
        printstatus: '-1',
        productname: '',
        reason: '',
        beizhu: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogShenPi: false,
      dialogSubmitAgain: false,
      apiShenPiBaoXiaoSHUrl: '',
      SubRule_ShenPiNewFyBxChaiLv_BuMen: false,
      SubRule_ShenPiNewFyBxChaiLv_CaiWu: false,
      SubRule_ShenPiNewFyBxChaiLv_FuZong: false,
      SubRule_ShenPiNewFyBxChaiLv_Zong: false,
      SubRule_ShenPiNewFyBxChaiLv_Print: false,
      dialogPrint: false,
      dialogView: false
    }
  },
  mounted () {
    this.useriderp = localStorage.getItem('Useriderp')
    this.apiGetShenPiNewFyBxChaiLvNum()
    this.apiGetShenPiNewFyBxChaiLvList()
    this.apiGetWorkprojectList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiNewFyBxChaiLv_BuMen', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiNewFyBxChaiLv_BuMen = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiNewFyBxChaiLv_CaiWu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiNewFyBxChaiLv_CaiWu = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiNewFyBxChaiLv_FuZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiNewFyBxChaiLv_FuZong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiNewFyBxChaiLv_Zong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiNewFyBxChaiLv_Zong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiNewFyBxChaiLv_Print', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiNewFyBxChaiLv_Print = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetShenPiNewFyBxChaiLvNum()
      this.apiGetShenPiNewFyBxChaiLvList()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addFormYanfaBx.attachment = url
    },
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    changeMultiErpUsers (rv) {
      this.keywords.createuserid = rv
    },
    countmoney () {
      var m = parseFloat(this.addFormYanfaBx.productnum) * parseFloat(this.addFormYanfaBx.productprice)
      this.addFormYanfaBx.money = m.toFixed(2)
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickdialogprint (row) {
      this.modelSubmitAgain.spid = row.Id

      this.dialogPrint = true
      var that = this
      var forprint = 1
      this.$nextTick(() => {
        that.$refs.PrintViewyanfabaoxiao.LoadData(row, forprint)
      })
    },
    clickView (row) {
      this.dialogView = true
      var that = this
      var forprint = 0
      this.$nextTick(() => {
        that.$refs.PrintViewyanfabaoxiao.LoadData(row, forprint)
      })
    },
    clickaddYanfaBx () {
      if (this.addFormYanfaBx.shoukuandanwei.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入供应商')
        return
      }
      if (this.addFormYanfaBx.contact.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入联系方式')
        return
      }
      if (this.addFormYanfaBx.productname.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入材料名称')
        return
      }
      if (this.addFormYanfaBx.reason.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入材料用途')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormYanfaBx.productnum)) {
        Vue.prototype.FunAlertMsg('请输入数量')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormYanfaBx.productprice)) {
        Vue.prototype.FunAlertMsg('请输入单价')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormYanfaBx.money)) {
        Vue.prototype.FunAlertMsg('请输入金额')
        return
      }
      this.apiAddShenPiNewFyBxChaiLv4()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickedit (row) {
      var that = this
      // 修改研发材料报销
      that.activeName = 'three'
      that.$refs.SubVuethree.LoadData(row, this.optionsproduct)
    },
    ShenHe0 (row) {
      this.dialogSubmitAgain = true
      this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH0
      this.modelSubmitAgain.spid = row.Id
      this.modelSubmitAgain.spreply = ''
    },
    ShenHe1234 (row, number) {
      this.dialogShenPi = true
      this.modelShenPi.spid = row.Id
      this.modelShenPi.spopinion = ''
      this.modelShenPi.iscaiwushenpi = false
      this.modelShenPi.moneytax = '0'
      if (number === 1) {
        this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH1
      }
      if (number === 2) {
        this.modelShenPi.iscaiwushenpi = true
        this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH2
      }
      if (number === 3) {
        this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH3
      }
      if (number === 4) {
        this.apiShenPiBaoXiaoSHUrl = Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH4
      }

      var that = this
      var forprint = 0
      this.$nextTick(() => {
        that.$refs.ShenPiViewyanfabaoxiao.LoadData(row, forprint)
      })
    },
    ShenHeOK () {
      this.dialogShenPi = false
      this.apiShenPiBaoXiaoSH(1)
    },
    ShenHeNO () {
      this.dialogShenPi = false
      this.apiShenPiBaoXiaoSH(-1)
    },
    SubmitAgain () {
      this.dialogSubmitAgain = false
      this.apiShenPiNewFyBxChaiLvSH0()
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiNewFyBxChaiLv(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetShenPiNewFyBxChaiLvNum()
      this.apiGetShenPiNewFyBxChaiLvList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetShenPiNewFyBxChaiLvList()
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.optionsproduct = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype <= 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiNewFyBxChaiLvNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.keywords.bomsn,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouid: that.keywords.jigouid,
        createuserid: that.keywords.createuserid,
        fytype: that.keywords.fytype,
        orderidcaigou: that.keywords.orderidcaigou,
        shoukuandanwei: that.keywords.shoukuandanwei,
        spstatus: that.keywords.spstatus,
        printstatus: that.keywords.printstatus,
        productname: that.keywords.productname,
        reason: that.keywords.reason,
        beizhu: that.keywords.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiNewFyBxChaiLvNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiNewFyBxChaiLvList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        bomsn: that.keywords.bomsn,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouid: that.keywords.jigouid,
        createuserid: that.keywords.createuserid,
        fytype: that.keywords.fytype,
        orderidcaigou: that.keywords.orderidcaigou,
        shoukuandanwei: that.keywords.shoukuandanwei,
        spstatus: that.keywords.spstatus,
        printstatus: that.keywords.printstatus,
        productname: that.keywords.productname,
        reason: that.keywords.reason,
        beizhu: that.keywords.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiNewFyBxChaiLvList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Attachments = []
              if (that.dataList[i].Attachment.length > 1) {
                that.dataList[i].Attachments = that.dataList[i].Attachment.split('@@@')
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiNewFyBxChaiLv4: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.addFormYanfaBx.bomsn,
        shoukuandanwei: that.addFormYanfaBx.shoukuandanwei,
        contact: that.addFormYanfaBx.contact,
        productname: that.addFormYanfaBx.productname,
        reason: that.addFormYanfaBx.reason,
        productnum: that.addFormYanfaBx.productnum,
        productprice: that.addFormYanfaBx.productprice,
        money: that.addFormYanfaBx.money,
        beizhu: that.addFormYanfaBx.beizhu,
        attachment: that.addFormYanfaBx.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiNewFyBxChaiLv4, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvNum()
            that.apiGetShenPiNewFyBxChaiLvList()

            // 清空添加
            that.addFormYanfaBx.bomsn = ''
            that.addFormYanfaBx.shoukuandanwei = ''
            that.addFormYanfaBx.contact = ''
            that.addFormYanfaBx.productname = ''
            that.addFormYanfaBx.reason = ''
            that.addFormYanfaBx.productnum = ''
            that.addFormYanfaBx.productprice = ''
            that.addFormYanfaBx.money = ''
            that.addFormYanfaBx.beizhu = ''
            that.addFormYanfaBx.attachment = ''
            that.$refs.MultiImgOrPdf.cleardata()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiNewFyBxChaiLv: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiNewFyBxChaiLv, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvNum()
            that.apiGetShenPiNewFyBxChaiLvList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiBaoXiaoSH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.modelShenPi.spid,
        spopinion: that.modelShenPi.spopinion,
        moneytax: that.modelShenPi.moneytax,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiBaoXiaoSHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvNum()
            that.apiGetShenPiNewFyBxChaiLvList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiNewFyBxChaiLvSH0: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.modelSubmitAgain.spid,
        spreply: that.modelSubmitAgain.spreply
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ShenPiNewFyBxChaiLvSH0, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvNum()
            that.apiGetShenPiNewFyBxChaiLvList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiNewFyBxChaiLvPrint: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.modelSubmitAgain.spid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ShenPiNewFyBxChaiLvPrint, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiNewFyBxChaiLvList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
